import VInputPercentage from './index.vue';

export default {
  install: (Vue) => Vue.component('VInputPercentage', VInputPercentage),
};
